export default "__VITE_ASSET__4f6Wm1ki__"